import { render, staticRenderFns } from "./TeamStudents.vue?vue&type=template&id=2a3cfaba&scoped=true&"
import script from "./TeamStudents.vue?vue&type=script&lang=js&"
export * from "./TeamStudents.vue?vue&type=script&lang=js&"
import style0 from "./TeamStudents.vue?vue&type=style&index=0&id=2a3cfaba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3cfaba",
  null
  
)

export default component.exports